import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Instagram, Twitter, Facebook } from 'lucide-react';
import { BRAND } from '../brand';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const cols = [
    {
      title: 'Mobility',
      links: [
        { to: '/how-it-works', label: t('howItWorks') },
        { to: '/become-mobilitier', label: t('becomeMobilitier') },
        { to: '/search', label: t('search') },
      ],
    },
    {
      title: 'Copa Mundial FIFA 2026',
      links: [
        { to: '/#mundial-2026', label: 'FIFA World Cup ready' },
        { to: '/search?location=Ciudad%20de%20M%C3%A9xico', label: 'CDMX' },
        { to: '/search?location=Monterrey', label: 'Monterrey' },
        { to: '/search?location=Guadalajara', label: 'Guadalajara' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { to: '/terms', label: t('termsAndConditions') },
        { to: '/privacy', label: t('privacyPolicy') },
      ],
    },
  ];

  return (
    <footer className="relative bg-black text-white font-mont overflow-hidden">
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-lime/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10 relative">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand col */}
          <div className="col-span-2 md:col-span-1">
            <img src={BRAND.logos.wordmarkLight} alt="Mobility" className="h-12 w-auto mb-5" />
            <p className="text-sm text-white/60 leading-relaxed font-light max-w-xs">
              La nueva plataforma de movilidad para México. Reserva un auto o publica el tuyo.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/15 hover:border-lime hover:text-lime grid place-items-center transition">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full border border-white/15 hover:border-lime hover:text-lime grid place-items-center transition">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/15 hover:border-lime hover:text-lime grid place-items-center transition">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-comfortaa font-bold text-sm tracking-wide mb-4 text-white">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/60 hover:text-lime transition font-light"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 font-light">
            © Mobility {year}. {t('allRightsReserved')}.
          </p>
          <p className="text-xs text-white/40 font-light">
            Hecho en México · Ready for FIFA World Cup 2026
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
